/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines a status log.
 */
export interface StatusLogDTO { 
    status?: string;
    /**
     * Date since when status is valid.
     */
    from?: string;
    /**
     * Date since till status is valid.
     */
    to?: string;
    /**
     * The identifier of user who did the status change.
     */
    modifiedBy?: string;
}

export class ClsStatusLogDTO { 
    status?: string = undefined;
    /**
     * Date since when status is valid.
     */
    from?: string = undefined;
    /**
     * Date since till status is valid.
     */
    to?: string = undefined;
    /**
     * The identifier of user who did the status change.
     */
    modifiedBy?: string = undefined;
}

